import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
// TODO: merge `d` attribute into one for 16px
const draw24px = 'M17,3.28a3.33,3.33,0,0,0-4.62,0L3.41,12.2a.75.75,0,0,0-.22.53V16.3a.75.75,0,0,0,.22.53l.11.09.13.07a.64.64,0,0,0,.28.06H7.51A.75.75,0,0,0,8,16.82l7.88-7.89,1-1a.58.58,0,0,0,.1-.12A3.24,3.24,0,0,0,17,3.28ZM7.19,15.54H4.69V13L11.83,5.9l2.5,2.5Zm8.7-8.7-.5.5-2.5-2.5.5-.5a1.81,1.81,0,0,1,2.5,0A1.77,1.77,0,0,1,15.89,6.84Zm4.87,14.65H3.24a.75.75,0,1,1,0-1.5H20.76a.75.75,0,0,1,0,1.5Z';
const icons = {
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const PencilLineIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'pencilLine'));
PencilLineIcon.displayName = 'PencilLineIcon';
PencilLineIcon.propTypes = Icon.propTypes;
PencilLineIcon.renderIcon = props => /*#__PURE__*/React.createElement(PencilLineIcon, props);
export default PencilLineIcon;
//# sourceMappingURL=PencilLineIcon.js.map